/**
 * Shared JWT utilities
 * Used by TokiContext, HambiContext, and aiChat service
 */

export const looksLikeJwt = (value) => {
    if (!value || typeof value !== 'string') return false;
    const parts = value.split('.');
    return parts.length === 3 && parts.every(Boolean);
};

export const decodeJwtPayload = (token) => {
    if (!looksLikeJwt(token)) return null;
    try {
        const payload = token.split('.')[1];
        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
        const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
        const decoded = atob(padded);
        return JSON.parse(decoded);
    } catch (error) {
        return null;
    }
};

export const isJwtExpired = (token) => {
    const payload = decodeJwtPayload(token);
    if (!payload || !payload.exp) return false;
    return payload.exp * 1000 < Date.now();
};
